import Image from "next/image";
import { CSSProperties } from "react";

import mainLogo from "@/assets/main-logo.svg";
// import since from "@/assets/since-2011-2.png";
import since from "@/assets/SINCE-2011-new.png";
import Link from "next/link";

interface Props {
  className?: string;
  style?: CSSProperties;
}

const MainLogo = ({ className, style }: Props) => {
  return (
    <Link href="/" className="flex items-center gap-2 pr-1.5">
      <Image
        src={mainLogo}
        alt="Gadget & Gear's Logo"
        width={60}
        height={50}
        objectFit="contain"
        className={className}
        unoptimized={true}
        style={style}
      />
      <span className="font-light">|</span>
      <Image
        src={since}
        alt="Gadget & Gear's Logo"
        width={60}
        height={60}
        objectFit="contain"
        className={className}
        unoptimized={true}
        style={style}
      />
    </Link>
  );
};

export default MainLogo;
